import AOS from 'aos';
import initializeMobileMenu from './menu';
import initializeCollapse from './blocks/collapse';
import initializeFiles from './blocks/files';
import initializeIconBoxes from './blocks/icon-boxes';
import initializeNumbersBlock from './blocks/numbers';
import initializeFancyBox from './fancybox';
import initializeGallerySection from './blocks/gallery-section';
import initializeGalleryGrid from "./blocks/gallery-grid";
import initializeForm from './utils/form';
import initializeBrands from './blocks/brands';
import initializeGallerySlider from './blocks/gallery-slider';
import initializeGalleryText from './blocks/gallery-text';
import initializeIconBoxesAnimation from './blocks/icon-boxes-animation';
import initializeSearch from './blocks/search';
// import initializeHomeSlider from './blocks/home-slider';
import blockImageSlider from './blocks/image-slider';
import './utils/scrollup';
import blockLogotypes from "./blocks/logotypes";
// import WooCommerce from './woo'

class App {
    constructor() {
        this.initialize();
    }

    initialize() {
        AOS.init({
            startEvent: 'load',
            disable: 'mobile',
            once: true,
            duration: 1000
        });
        initializeForm();
        initializeFancyBox();
        initializeMobileMenu();
        initializeCollapse();
        initializeFiles();
        initializeIconBoxes();
        initializeNumbersBlock();
        initializeGallerySection();
        initializeGalleryGrid();
        initializeBrands();
        initializeGallerySlider();
        initializeGalleryText();
        initializeIconBoxesAnimation();
        initializeSearch();
        blockImageSlider();
        blockLogotypes();
        // initializeHomeSlider();
        // const Woo = new WooCommerce();



        document.querySelector('header .lang-switch .current').addEventListener('click', function (e) {
            e.stopPropagation();
            var dropdown = this.parentNode.querySelector('.dropdown');
            console.log(dropdown);
            if (dropdown.classList.contains('open')) {
                console.log('remove');
                dropdown.classList.remove('open');
            } else {
                console.log('open');
                dropdown.classList.add('open');
            }
        });


        document.querySelector('body').addEventListener('click', function (e) {
            var langswitch = document.querySelector('header .lang-switch');
            var dropdown = langswitch.querySelector('.dropdown');
            if (e.target != langswitch && e.target != dropdown) {
                if (dropdown.classList.contains('open')) {
                    dropdown.classList.remove('open');
                }
            }
        });





    }
}

function initializeApp() {
    const app = new App();
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeApp);
} else {
    initializeApp();
}
